import {Amplify} from "aws-amplify";
import {CookieStorage} from "aws-amplify/utils";
import {cognitoUserPoolsTokenProvider} from "aws-amplify/auth/cognito";

const COGNITO_USERPOOL_ID = import.meta.env.VITE_APP_COGNITO_USERPOOL_ID as string;
const COGNITO_CLIENT_ID = import.meta.env.VITE_APP_COGNITO_CLIENT_ID as string;
const COGNITO_IDENTITY_POOL_ID = import.meta.env.VITE_APP_COGNITO_IDENTITY_POOL_ID as string;
const ANALYTICS_FIREHOSE_REGION = import.meta.env.VITE_APP_ANALYTICS_FIREHOSE_REGION as string;

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: COGNITO_USERPOOL_ID,
            userPoolClientId: COGNITO_CLIENT_ID,
            identityPoolId: COGNITO_IDENTITY_POOL_ID,
        },
    },
    Analytics: {
        KinesisFirehose: {
            region: ANALYTICS_FIREHOSE_REGION,
        },
    },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(
    new CookieStorage({
        domain: window.location.hostname,
        path: "/",
        secure: true,
    }),
);
